import { defineNuxtPlugin, ref, useState } from "#imports";
import { getOidcClient } from "../utils/client.js";
export default defineNuxtPlugin({
  name: "@apptegy/nuxt-auth/plugin",
  async setup() {
    const state = useState("auth", ref);
    const user = await getOidcClient().getUser();
    state.value = user ? { loggedIn: true, user } : { loggedIn: false, user: null };
    return {
      provide: {
        auth: state
      }
    };
  }
});
